const STORAGE_KEY = '_shu';

function read(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : [];
  } catch {
    return [];
  }
}

export function getDeviceAccounts(): string[] {
  return read();
}

export function recordDeviceAccount(id: string): void {
  if (typeof window === 'undefined' || !id) return;
  try {
    const current = read();
    if (current.includes(id)) return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify([...current, id]));
  } catch {
    // Android WebViews throw on partitioned/blocked storage — ignore.
  }
}
